<template>
    <div class="clause-wrapper">
        <div class="clause-body">
            <header class="header">保障责任</header>
            <div class="content">
                <p style="text-align:center">
                    <span style="font-size:19px;font-family:&#39;微软雅黑&#39;,sans-serif">保险责任说明</span>
                </p>
                <p style="text-indent:48px">
                    <strong><span style="font-size:16px;font-family:&#39;微软雅黑&#39;,sans-serif;color:red">本保险责任说明为保险责任摘要，请结合投保须知查看，具体的保险责任以保险公司出具的正式保单为准；</span></strong>
                </p>
                <p class="MsoListParagraph" style="margin-left:28px">
                    <strong><span style=";font-family:&#39;微软雅黑&#39;,sans-serif">一、</span></strong><strong><span style=";font-family:&#39;微软雅黑&#39;,sans-serif">普货的保险责任如下</span></strong>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">（一）火灾、爆炸；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">（二）运输工具发生碰撞、出轨、倾覆、坠落、搁浅、触礁、沉没；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">（三）隧道、桥梁、码头坍塌；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">（四）碰撞、挤压导致包装破裂或容器损坏；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">（五）符合安全运输规定而遭受雨淋；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style="font-family: 微软雅黑, sans-serif;">（六）<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 9px; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="font-family: 微软雅黑, sans-serif;">装卸人员违反操作规程进行装卸、搬运。</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style="font-family: 微软雅黑, sans-serif;">（七）<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 9px; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="font-family: 微软雅黑, sans-serif;">保险事故发生后，被保险人因保险事故而被提起仲裁或者诉讼的，对应由被保险人支付的仲裁或诉讼费用以及事先经保险人书面同意支付的其他必要的、合理的费用（以下简称“法律费用”），保险人按照本保险合同约定也负责赔偿。</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px">
                    <strong><span style=";font-family:&#39;微软雅黑&#39;,sans-serif">二、</span></strong><strong><span style=";font-family:&#39;微软雅黑&#39;,sans-serif">煤炭/钢材/矿石/水泥/化肥/粮食的保险责任如下:</span></strong>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">（一）火灾、爆炸；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style=";font-family:&#39;微软雅黑&#39;,sans-serif">（二）运输工具发生碰撞、出轨、倾覆、坠落、搁浅、触礁、沉没；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style="font-family: 微软雅黑, sans-serif;">（三）<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 9px; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="font-family: 微软雅黑, sans-serif;">隧道、桥梁、码头坍塌；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style="font-family: 微软雅黑, sans-serif;">（四）<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 9px; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="font-family: 微软雅黑, sans-serif;">碰撞、挤压导致包装破裂或容器损坏；</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style="font-family: 微软雅黑, sans-serif;">（五）<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 9px; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="font-family: 微软雅黑, sans-serif;">装卸人员违反操作规程进行装卸、搬运。</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px;text-indent:0">
                    <span style="font-family: 微软雅黑, sans-serif;">（六）<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 9px; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp; </span></span><span style="font-family: 微软雅黑, sans-serif;">保险事故发生后，被保险人因保险事故而被提起仲裁或者诉讼的，对应由被保险人支付的仲裁或诉讼费用以及事先经保险人书面同意支付的其他必要的、合理的费用（以下简称“法律费用”），保险人按照本保险合同约定也负责赔偿。</span>
                </p>
                <p class="MsoListParagraph" style="margin-top:0;margin-right:0;margin-bottom: 10px;margin-left:28px">
                    <strong><span style=";font-family:&#39;微软雅黑&#39;,sans-serif">三、</span></strong><strong><span style=";font-family:&#39;微软雅黑&#39;,sans-serif">生鲜、易碎品保险责任</span></strong>
                </p>
                <p class="MsoListParagraph" style="margin-left: 28px; text-indent: 0px; line-height: 150%;">
                    <strong><span style=";line-height:150%;font-family:&#39;微软雅黑&#39;,sans-serif">仅承保因火灾、爆炸、交通工具发生碰撞、倾覆造成的损失。</span></strong>
                </p>
            </div>
            <div class="close-btn" @click="closeClause">关闭</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "guaranteeRes",
        methods:{
            closeClause(){
                this.$router.back(-1)
            }
        }
    }
</script>

<style scoped lang="scss">
    .clause-wrapper{
        overflow: hidden;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0, 0, 0, 0.3);
        z-index: 9999;
        .clause-body{
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
            color: #333;
            background-color: #fff;
            z-index: 9999;
            -webkit-transition: 300ms all;
            transition: 300ms all;
            .header{
                height: 13.33vw;
                line-height: 13.33vw;
                font-size: 4.8vw;
                font-weight: bold;
                border-bottom: .27vw solid #f5f5f9;
                text-align: center;
            }
            .content{
                height: 60vh;
                padding: 2.67vw 5vw;
                overflow: auto;
                text-align:justify;
            }
            .close-btn{
                height: 12vw;
                line-height: 12vw;
                text-align: center;
                color: #ffffff;
                background: #3385ff;
            }
        }
    }
</style>